import { useMutation } from 'react-query';

import { renamePoapViewName as mutationFn } from 'api/endPoints/renamePoapViewName';

export const useMutationRenamePoapViewName = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    viewId: number;
    newName: string;
}
